export default class ProjetoTag {

  constructor(
    IdProjeto = null,
    IdTag = null,
    Descricao = ''
  ) {
    this.IdProjeto = IdProjeto;
    this.IdTag = IdTag;
    this.Descricao = Descricao;
  }
  
}